// extracted by mini-css-extract-plugin
export var closeButton = "_n2-1";
export var closeX = "_n2-3";
export var container = "_n2-0";
export var image = "_n2-2";